import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = {
  key: 1,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "btn btn-secondary" }
const _hoisted_6 = {
  key: 2,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { class: "navbar navbar-expand-md navbar-dark bg-dark" }
const _hoisted_12 = { class: "container" }
const _hoisted_13 = { class: "form-inline my-2 my-lg-0 ml-auto" }
const _hoisted_14 = { class: "btn btn-light mr-2" }
const _hoisted_15 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_16 = { class: "dropdown-menu" }
const _hoisted_17 = { class: "container" }
const _hoisted_18 = { class: "mt-5 font-weight-light" }
const _hoisted_19 = { class: "text-lowercase" }
const _hoisted_20 = { class: "lead" }
const _hoisted_21 = { class: "navbar navbar-expand-md navbar-light bg-light" }
const _hoisted_22 = { class: "form-inline my-2 my-lg-0 ml-auto" }
const _hoisted_23 = { class: "table table-hover mt-3" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = {
  class: "progress",
  style: {"height":"30px"}
}
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "btn btn-outline-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlternativeDetailsDialog = _resolveComponent("AlternativeDetailsDialog")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AlternativeDetailsDialog, { viewModel: _ctx.alternativeDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    (!_ctx.initialized)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("h3", { class: "text-center" }, [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }),
            _createTextVNode(" Loading...")
          ], -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    (_ctx.initialized && _ctx.IsClosed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "card-title" }, "Survey is closed", -1 /* CACHED */)),
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "card-text lead" }, "Please wait for the host to open this survey or go to the meeting.", -1 /* CACHED */)),
              _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Go to the meeting", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.MeetingUrl]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.initialized && !_ctx.IsClosed && _ctx.SurveyQuestionsCount === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h5", _hoisted_9, "Empty survey: " + _toDisplayString(_ctx.SurveyName), 1 /* TEXT */),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "card-text lead" }, "Sorry. This survey has no questions. Please contact the person who asked you to complete the survey for advice.", -1 /* CACHED */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.initialized && !_ctx.IsClosed && _ctx.SurveyQuestionsCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("nav", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("form", _hoisted_13, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("Join Meeting", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, _ctx.MeetingUrl]
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[10] || (_cache[10] = _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light dropdown-toggle",
                    "data-toggle": "dropdown"
                  }, " My votes ", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadVotes && _ctx.downloadVotes(...args)))
                    }, "Download to xls")
                  ])
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("a", {
                  class: "btn btn-light",
                  href: "https://www.transparentchoice.com/user-guide/respondents-scoring",
                  title: "Respondents guide: Scoring Projects",
                  target: "_blank"
                }, [
                  _createElementVNode("i", {
                    class: "fa fa-info",
                    "aria-hidden": "true"
                  })
                ], -1 /* CACHED */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h3", _hoisted_18, "Survey: " + _toDisplayString(_ctx.SurveyName), 1 /* TEXT */),
            _createElementVNode("p", null, [
              _createTextVNode(" Assesss " + _toDisplayString(_ctx.Alternatives.length) + " ", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.AlternativesLabel), 1 /* TEXT */),
              _createTextVNode(" by answering " + _toDisplayString(_ctx.SurveyQuestionsCount) + " questions. ", 1 /* TEXT */)
            ]),
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.SurveyDescription), 1 /* TEXT */),
            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("nav", _hoisted_21, [
              _createElementVNode("form", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control mr-sm-2",
                  type: "search",
                  placeholder: "Search...",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.SearchPhrase]
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_23, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.AlternativeLabel), 1 /* TEXT */),
                  _createElementVNode("th", null, [
                    _createElementVNode("a", {
                      class: "pointer",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ToggleOrderByProgressCommand && _ctx.ToggleOrderByProgressCommand(...args)))
                    }, " Progress ")
                  ]),
                  _cache[12] || (_cache[12] = _createElementVNode("th", { style: {"width":"120px"} }, null, -1 /* CACHED */))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AlternativesView, (a) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: a.AlternativeId
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        class: "text-dark",
                        onClick: ($event: any) => (_ctx.showAlternativeDetails(a))
                      }, _toDisplayString(a.Name), 9 /* TEXT, PROPS */, _hoisted_24)
                    ]),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", {
                          class: "progress-bar",
                          role: "progressbar",
                          style: _normalizeStyle({width: a.Progress + '%'})
                        }, null, 4 /* STYLE */)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_27, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_28, [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("Evaluate", -1 /* CACHED */)
                      ]))])), [
                        [_directive_sanitizedHref, a.EvaluationUrl]
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}